export default __webpack_public_path__ + "static/media/ep6mainVid.0acc53c5.jpg";